import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { getTwelveDataTimeSeries } from "../../services/api/http";

const RANGE_MAP = {
  "1D": { interval: "1day", outputsize: 78 },
  "5D": { interval: "1day", outputsize: 10 },
  "1M": { interval: "1day", outputsize: 30 },
  "6M": { interval: "1day", outputsize: 180 },
  YTD: { interval: "1day", outputsize: 365 },
};

export default class PriceChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      mode: "1D",
      loading: false,
    };
    this.cache = {};
  }

  componentDidMount() {
    this.loadMode("1D");
  }

  componentDidUpdate(prevProps) {
    if (prevProps.ticker !== this.props.ticker) {
      this.cache = {};
      this.loadMode(this.state.mode, true);
    }
  }

  loadMode = (mode, force = false) => {
    const ticker = this.props.ticker;
    if (!ticker) return;

    const config = RANGE_MAP[mode] || RANGE_MAP["1D"];
    const key = `${ticker}_${mode}`;

    if (!force && this.cache[key]) {
      this.setState({
        data: this.cache[key],
        mode,
        loading: false,
      });
      return;
    }

    this.setState({ loading: true, mode });

    getTwelveDataTimeSeries(ticker, config.interval, config.outputsize)
      .then((resp) => {
        const values = resp?.data?.values || [];
        const data = values
          .slice()
          .reverse()
          .map((entry) => ({
            xaxis: entry.datetime,
            close: Number(entry.close),
          }))
          .filter((entry) => Number.isFinite(entry.close));
        this.cache[key] = data;
        this.setState({
          data,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({
          data: null,
          loading: false,
        });
      });
  };

  onTabClick = (e) => {
    const txt = e.target.textContent || e.target.innerText;
    this.loadMode(txt);
  };

  render() {
    const { data, loading } = this.state;

    return (
      <>
        <div className="chart-button-container" style={{ display: "flex", gap: "10px", flexWrap: "wrap", justifyContent: "flex-end" }}>
          {Object.keys(RANGE_MAP).map((key) => (
            <button
              key={key}
              id={`ch-${key.toLowerCase()}`}
              type="button"
              className={`home-v3-button ${this.state.mode === key ? "is-primary" : "is-secondary"}`}
              onClick={this.onTabClick}
            >
              {key}
            </button>
          ))}
        </div>
        {loading ? <p className="meta-copy" style={{ marginTop: "12px" }}>Loading chart...</p> : null}
        {data && data.length > 0 ? (
          <ResponsiveContainer width={"100%"} height={320}>
            <LineChart width={500} height={400} data={data} margin={{ top: 10, right: 20, left: 0, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="xaxis" />
              <YAxis />
              <Tooltip />
              <Line
                type="monotone"
                dataKey="close"
                stroke="#29abe2"
                fill="#29abe2"
                dot={false}
                strokeWidth={2}
              />
              <Legend />
            </LineChart>
          </ResponsiveContainer>
        ) : null}
      </>
    );
  }
}
